import r from "./index820.js";
var a = r["__core-js_shared__"];
export {
  a as default
};
